const listActions = {
  GET_CURRENT_LANGUE    : 'GET_CURRENT_LANGUE',
  CHANGE_CURRENT_LANGUE : 'CHANGE_CURRENT_LANGUE',

  SEND_EMAIL_START   : 'SEND_EMAIL_START',
  SEND_EMAIL_SUCCESS : 'SEND_EMAIL_SUCCESS',
  SEND_EMAIL_FAIL    : 'SEND_EMAIL_FAIL',

  SEND_EMAIL_ORDER_START   : 'SEND_EMAIL_ORDER_START',
  SEND_EMAIL_ORDER_SUCCESS : 'SEND_EMAIL_ORDER_SUCCESS',
  SEND_EMAIL_ORDER_FAIL    : 'SEND_EMAIL_ORDER_FAIL',

  GET_CALENDAR_START   : 'GET_CALENDAR_START',
  GET_CALENDAR_SUCCESS : 'GET_CALENDAR_SUCCESS',
  GET_CALENDAR_FAIL    : 'GET_CALENDAR_FAIL',

  GET_TEMPLATES_START   : 'GET_TEMPLATES_START',
  GET_TEMPLATES_SUCCESS : 'GET_TEMPLATES_SUCCESS',
  GET_TEMPLATES_FAIL    : 'GET_TEMPLATES_FAIL',

  EDIT_TEMPLATES         : 'EDIT_TEMPLATES',
  EDIT_TEMPLATES_SUCCESS : 'EDIT_TEMPLATES_SUCCESS',
  UPDATE_TEMP_TEMPLATES  : 'UPDATE_TEMP_TEMPLATES',

  LOGIN_START   : 'LOGIN_START',
  LOGIN_FAIL    : 'LOGIN_FAIL',
  LOGIN_SUCCESS : 'LOGIN_SUCCESS',
  SET_TOKEN     : 'SET_TOKEN',
};

export default listActions;



// WEBPACK FOOTER //
// ./src/store/actions/listActions.js